import { ENDPOINT } from "src/constants";

import { Http } from "../http";

import { StaticPageResponse } from "./static-pages.types";

export const getStaticPageContent = (page: string): StaticPageResponse =>
  Http.get(`${ENDPOINT}/web/${encodeURIComponent(page)}`);
